import { Fragment } from 'react';
import { useTranslation } from 'next-i18next';
import { WindowType } from '@typescript/index';
import InstructionListItem from '@features/instructions/sections/GroupList/components/InstructionListBlock/InstructionListItem';
import styles from '@features/instructions/sections/GroupList/InstructionList.styles';
import Icon from '@components/icons/Icon';
type PropsType = {
  items: void | [string, unknown][];
  windowType: WindowType;
};
const getLastPartBeforeSlash = str => {
  const lastSlashIndex = str.lastIndexOf('/');
  if (lastSlashIndex !== -1) {
    return str.substring(lastSlashIndex + 1);
  }
  return str; // Jeśli nie ma '/', zwróć cały ciąg
};
const SelectCodeToText = code => {
  switch (code) {
    case 'PRODUCT_CATEGORY_CERTIFICATE':
    case 'PRODUCT_CERTIFICATE':
      return 'instructionCert';
    case 'PRODUCT_PRODUCER_ATEST':
      return 'instructionAtest';
    case 'CATEGORY_CATALOG':
    case 'PRODUCT_CATALOG':
      return 'instructionCatalog';
    case 'PRODUCT_INSTRUCTION':
    case 'PRODUCT_CATEGORY_INSTRUCTION':
    case 'PRODUCT_PRODUCER_INSTR':
    case 'PRODUCT_MENU_INSTR':
      return 'instructionInst';
    default:
      return code;
  }
};
const DescriptionsSection = ({
  items,
  windowType
}: PropsType) => {
  const {
    t
  } = useTranslation('layouts');
  return <>
      {items && Object.values(items).map(item => {
      const name = item[0];
      const details: React.ReactNode | null = !!item[1] && <ul sx={styles.downloadLinkList}>
              {item[1] && Object.values(item[1]).map(one => <li key={`${one.category_id}-${Math.random()}`}>
                    <a sx={styles.downloadLink} href={one.file} target="_blank" rel="noreferrer" title={`${t(SelectCodeToText(one.file_type))}: ${getLastPartBeforeSlash(one.file)} [${one.name}] ${t('footer.links.opensInNewWindow')}`}>
                      <Icon icon="Download" size="24px" />
                      {t(SelectCodeToText(one.file_type))}: {getLastPartBeforeSlash(one.file)} [{one.name}]
                    </a>
                  </li>)}
            </ul>;
      return <Fragment key={item[0]}>
              <div sx={styles.descriptionContainer} data-cy="DescriptionContainerItem">
                <InstructionListItem title={name || ''} windowType={windowType}>
                  <div sx={styles.descriptionContainerInner} data-cy="InstructionListItem">
                    <div sx={styles.descriptionDetails}>{details || ''}</div>
                  </div>
                </InstructionListItem>
              </div>
            </Fragment>;
    })}
    </>;
};
export default DescriptionsSection;